/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListVariantsCatalogQueryResponse,
  ListVariantsCatalogQueryParams,
} from '../types/ListVariantsCatalog'

function getListVariantsCatalogUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/products/catalog/variants/` as const,
  }
  return res
}

/**
 * @description Get paginated variants catalog.
 * GET /variants/
 * Query Parameters:
 * - search: Search by SKU, name, UPC/GTIN, or product name
 * - match_status: Filter by status (matched, unmatched, ignored, all)
 * - product: Filter by product ID (list, supports -1 for unmatched)
 * - type: Filter type for multi-select logic (one, all, neither)
 * - sort/ordering: Field to sort by (with optional - prefix for descending)
 * - page: Page number (default: 1)
 * - limit/page_size: Items per page (default: 50, max: 1000)
 * Date Range Filters (use _greater/_less suffixes):
 * - created_greater/less: Filter by creation date
 * - modified_greater/less: Filter by modification date
 * Returns:
 * {
 * "results": [...],
 * "count": total_count,
 * "page": page,
 * "page_size": page_size,
 * "unmatched_count": unmatched_count
 * }
 * @summary List variants catalog
 * {@link /api/v1/products/catalog/variants/}
 */
export async function listVariantsCatalog(
  params?: ListVariantsCatalogQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListVariantsCatalogQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListVariantsCatalogUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
